export default "__VITE_ASSET__1d46bd5f__"